import React from 'react'
import { Link } from 'react-router-dom';
function Addsection({datas}) {
    return (
        <div>
            <div class="banner-statistics-area section-padding add-sec">
                <div class="container">
                    <div class="row row-20 mtn-20">
                        {datas !== undefined && datas.length > 0 ? datas.map((item) => {
                            return (
                                <div class="col-md-6  col-sm-12 " key={item.ads_id}>
                                    <figure class="banner-statistics mt-20">
                                        <Link to={item.link}>
                                            <img src={item.image} alt="product banner" />
                                        </Link>
                                        
                                        <div class="banner-content text-right">
                                            <h5 class="banner-text1">{item.title}</h5>
                                            <h2 class="banner-text2">{item.main_title}</h2>
                                        </div>
                                    </figure>
                                </div>
                            )
                        }) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Addsection
